import React from 'react'

import { Grid } from '../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../packages/kiti/components/presentation/Text'
import { useInitialFieldValuesFormatter } from '../../../utils/helpers/fields'
import FieldValuesFormInputItem from './FieldValuesFormInputItem'
import FieldsLoader, { useFields } from './_load/FieldsLoader'
import Line from '../../../packages/kiti/components/helpers/Line'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const FieldsForm = ({ hideTitle, origin, path, isPropSnakeCase, canEditSignature }) => {
  const fields = useFields()
  useInitialFieldValuesFormatter(origin, path, isPropSnakeCase)
  if (!fields?.length) return false

  return (
    <>
      {!hideTitle && (
        <>
          <Separator weight={2} />
          <Title size="xxsmall" bold color="dark3">
            Campos adicionais
          </Title>
          <Line />
          <Separator weight={4} />
        </>
      )}

      <Grid paddingGutter={0.5} wrap>
        {fields.map((field, index) => (
          <FieldValuesFormInputItem
            key={field.id}
            field={field}
            fieldValuesPath={path}
            isPropSnakeCase={isPropSnakeCase}
            canEditSignature={canEditSignature}
          />
        ))}
      </Grid>
    </>
  )
}

const Wrapper = ({ ...props }) => (
  <FieldsLoader origin={props.origin}>
    <FieldsForm {...props} />
  </FieldsLoader>
)

export default Wrapper
